.ProgressDetailed {
    position: relative;
    padding: 1.5rem;

    @media (min-width: 640px) {
        padding: 2rem;
    }
}

.ProgressDetailed__header {
    margin-bottom: 1.5rem;
}

.ProgressDetailed__header__actions {
    float: right;
}

.ProgressDetailed__description {
    margin-top: 0.5rem;
    color: var(--soniq-t--global--text--color--label--default);
    max-width: 42rem;
}

.ProgressDetailed__progressRow {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.ProgressDetailed__progressBar {
    flex: 1;
    height: 4px;
    border-radius: 999px;
    background: var(--soniq-t--global--border--color--card--default);
    overflow: hidden;
}

.ProgressDetailed__progressFill {
    height: 100%;
    background: var(--soniq-t--global--palette--hot-pink);
    border-radius: 999px;
    transition: width 0.4s ease;
}

.ProgressDetailed__tasks {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.75rem;

    @media (min-width: 640px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
    }
}

.ProgressDetailed__task {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 1.25rem;
    min-height: 10rem;

    &.isStatusComplete {
        border-color: var(--soniq-t--global--border--color--status--success--default);
    }

    &.isStatusInProgress {
        border-color: var(--soniq-t--global--border--color--accent--active--default);
    }
}

.ProgressDetailed__taskIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    height: 2.75rem;
    margin-bottom: 1rem;
    border-radius: 0.625rem;
    border: 1px solid var(--soniq-t--global--border--color--card--default);
    background: var(--soniq-t--global--background--color--surface--panel-subtle);
    font-size: 1.5rem;
    line-height: 1;
}

.ProgressDetailed__taskStatus {
    position: absolute;
    top: 1rem;
    right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 999px;

    &.isStatusComplete {
        border: 1px solid var(--soniq-t--global--border--color--status--success--default);
        background: var(--soniq-t--global--background--color--status--success--default);
        color: var(--soniq-t--global--text--color--status--success--default);
    }

    &.isStatusSkipped {
        border: 1px solid var(--soniq-t--global--border--color--status--muted--default);
        background: var(--soniq-t--global--background--color--status--muted--default);
        color: var(--soniq-t--global--text--color--status--muted--default);
    }
}

.ProgressDetailed__taskDescription {
    flex-grow: 1;
    margin-top: 0.375rem;
    color: var(--soniq-t--global--text--color--label--default);
}

.ProgressDetailed__taskActions {
    margin-top: 1rem;
}
